export default __webpack_public_path__ + "static/media/icon_locked.3eaeea4a.png";